import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCurrencyConfig } from "types/shared/currency";
export function formatSecondsToHours(seconds, showSeconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor(seconds % 3600 / 60);
  const remainingSeconds = seconds % 60;
  let result = "";
  if (hours > 0) {
    result += "".concat(hours, "h ");
  }
  if (minutes > 0 || hours > 0) {
    result += "".concat(minutes, "m ");
  }
  if (showSeconds) {
    if (remainingSeconds > 0 || hours === 0 && minutes === 0) {
      result += "".concat(remainingSeconds, "s");
    }
  }
  return result.trim();
}
export function formatCurrency(value, configs) {
  var _config$symbol;
  const defaultCurrencyConfig = _objectSpread(_objectSpread({}, getCurrencyConfig(configs.currency)), {}, {
    usePrefix: false,
    compact: false
  });
  const config = _objectSpread(_objectSpread({}, defaultCurrencyConfig), configs);
  let configResult = new Intl.NumberFormat(config.locale, {
    style: "currency",
    currency: config.currency,
    minimumFractionDigits: config.minFractionDigits,
    maximumFractionDigits: config.maxFractionDigits,
    notation: config.compact ? "compact" : "standard"
  }).format(value);
  if (configResult && config.symbol && configResult.includes((_config$symbol = config.symbol) !== null && _config$symbol !== void 0 ? _config$symbol : '')) {
    configResult = configResult.replace(config.symbol, config.symbol + ' ');
  }
  return config.usePrefix ? config.prefix + configResult : configResult;
}
export function getPriceByCurrency(price, currency) {
  var _price;
  if (!price || !currency) {
    return 0;
  }
  const priceFromCurrencies = price ? (_price = price === null || price === void 0 ? void 0 : price[currency]) !== null && _price !== void 0 ? _price : 0 : price !== null && price !== void 0 ? price : 0;
  return priceFromCurrencies;
}
export function isZeroOrNull(value) {
  return value === 0 || value === "0" || value === null || value === "";
}
export const formatNumberDecimals = (value, decimals) => {
  return Math.round(value * 10 ** decimals) / 10 ** decimals;
};
export const formatNumberWithSeparator = function (value) {
  let minimumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let maximumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[,\s]/g, '')) : value;
  if (isNaN(numericValue)) {
    return '0';
  }
  return new Intl.NumberFormat('en-US', {
    useGrouping: true,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits
  }).format(numericValue);
};